'use client';

import { Pie, PieChart } from 'recharts';

import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';

type Props = {
  config: ChartConfig;
  dataKey: string;
  nameKey: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
};

// 🎑 View
export default function Chart({ config, data, dataKey, nameKey }: Props) {
  return (
    <ChartContainer config={config} className='mx-auto aspect-square max-h-[250px]'>
      <PieChart>
        <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
        {/* Percentage radius, not px: a fixed 70px inner radius exceeds the computed outer radius
            below ~185px of chart width, and recharts then renders no sectors at all. */}
        <Pie data={data} dataKey={dataKey} nameKey={nameKey} innerRadius='55%' cornerRadius={4} paddingAngle={4} />
      </PieChart>
    </ChartContainer>
  );
}
